import { Box, Paper } from '@mui/material';
import Table from 'pages/PosSettings/Table/Table';
import { routes } from 'pages/PosSettings/Tabs/PosTabs';
import Sections from 'pages/PosSettings/Sections/Sections';
import FloorPlanBuilder from 'pages/PosSettings/FloorPlan/FloorPlanBuilder';
import { Route, Switch, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ErrorBoundaryWrapper from 'components/ErrorBoundaryWrapper';
import usePosSettings from 'pages/PosSettings/hooks/usePosSettings';
import { isLayoutEditorEnabled } from 'pages/PosSettings/FloorPlan/floorPlanStorage';

const PosSettings = () => {
  usePosSettings();
  const { currentBusiness } = useSelector(({ business }) => business);
  const layoutEditorEnabled = isLayoutEditorEnabled(currentBusiness);

  return (
    <Box>
      <ErrorBoundaryWrapper>
        <Paper className="order-content">
          <Box sx={{ p: 2 }}>
            <Switch>
              <Route exact path="/table-setup/tables" component={Table} />
              <Route
                exact
                path="/table-setup/sections"
                component={Sections}
              />
              {layoutEditorEnabled ? (
                <Route
                  exact
                  path="/table-setup/floor-plan"
                  component={FloorPlanBuilder}
                />
              ) : null}
              <Redirect to={`/table-setup${routes[0]?.path}`} />
            </Switch>
          </Box>
        </Paper>
      </ErrorBoundaryWrapper>
    </Box>
  );
};

export default PosSettings;
